export default __webpack_public_path__ + "static/23-8b9dda897aeb31d0ea16220d6482451c.webp";